import { render, staticRenderFns } from "./TooltipFeedback.vue?vue&type=template&id=6344d421"
import script from "./TooltipFeedback.vue?vue&type=script&lang=js"
export * from "./TooltipFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports